import { Section, TableOfContent } from '../../../typings/interfaces';
import { ARABIC } from '../../../assets/images';
// Arabic
const ARSection: Section[] = [
  {
    name: '1: مراجع ونبذة عامة',
    subSections: [
      {
        name: 'تمهيد',
        page: 3,
      },
      {
        name: 'الغرض وتطبيقات الدليل الميداني',
        page: 4,
      },
      {
        name: 'التعريفات الرئيسية',
        page: 5,
      },
      {
        name: 'التسلسل الهرمي للضوابط',
        page: 6,
      },
    ],
  },
  {
    name: '2:(LIFEsavers) قواعد الحفاظ على الحياة',
    subSections: [
      {
        name: 'المركبات اآللية – سالمة حركة المرور',
        page: 9,
      },
      {
        name: 'العمل في أماكن مرتفعة',
        page: 12,
      },
      {
        name: '(MPE) معدات متنقلة مزودة بالطاقة',
        page: 18,
      },
      {
        name: 'القفل ووضع عالمة تحذير لمنع التشغيل - عزل الطاقة',
        page: 22,
      },
      {
        name: 'األعمال الكهربائية',
        page: 25,
      },
      {
        name: 'المكان المغلق',
        page: 29,
      },
      {
        name: 'مجموعة المواد والتخزين',
        page: 32,
      },
      {
        name: 'سالمة عربة القطار',
        page: 36,
      },
      {
        name: 'أعمال الحفر والخنادق',
        page: 41,
      },
      {
        name: 'الرفع والمعدات',
        page: 45,
      },
      {
        name: 'مواد خطرة',
        page: 49,
      },
      {
        name: 'عمل ساخن',
        page: 50,
      },
    ],
  },
  {
    name: '3: المصادرة  واألدوات اإلضافية',
    subSections: [
      {
        name: 'العمل على المياه وحولها',
        page: 54,
      },
      {
        name: 'األشياء المسقطة أو الساقطة',
        page: 57,
      },
      {
        name: 'اختبار الغالف الجوي / الغاز',
        page: 61,
      },
      {
        name: 'توصيل المعلومات عن المواد الكيميائية الخطرة',
        page: 65,
      },
    ],
  },
  {
    name: '4:  ممارسات إدارة السالمة بكارجيل',
    subSections: [
      {
        name: 'المصطلحات األساسية',
        page: 68,
      },
      {
        name: '(SIF) تحديد اإلصابات الخطيرة والوفيات ',
        page: 70,
      },
      {
        name: '(SIFp) تصنيف اإلصابات الخطيرة وحاالت الوفاة المحتملة',
        page: 72,
      },
      {
        name: 'جدول معايير التحديد التلقائي لإلصابات الخطيرة وحاالت الوفاة',
        page: 74,
      },
      {
        name: '(HOP) األداء البشري والتنظيمي',
        page: 74,
      },
    ],
  },
];

const ARTableOfContent: TableOfContent = {
  language: 'ar',
  sections: ARSection,
  label: 'جدول المحتويات',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (ar_SA)_DIGITAL_CROPPED.pdf',
  hopPocket: 'دليل HOP المحمول في الجيب',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Arabic.pdf',
  source: ARABIC,
};

export default ARTableOfContent;
